import RenderIf from "common/components/RenderIf";
import useWhitelabelCustomization from "common/hooks/useWhitelabelCustomization";

import Communication from "./Communication";
import Email from "./Email";
import FullName from "./FullName";
import Password from "./Password";

export default function ProfileSettings() {
  const { whitelabelCustomization } = useWhitelabelCustomization();

  return (
    <div>
      <FullName isEditable={!whitelabelCustomization} />
      <Email isEditable={!whitelabelCustomization} />
      <RenderIf condition={!whitelabelCustomization}>
        <Password />
        <Communication />
      </RenderIf>
    </div>
  );
}
